/** @jsx jsx */
import { jsx } from '@balance-web/core';
import { Text } from '@balance-web/text';
import type { ReactNode } from 'react';
import { theme } from '@balance-web/theme';

import { maybeMapCombinationKey } from './maybeMapCombinationKey';

type Props = {
  keys: Array<ReactNode>;
  variant: 'text' | 'tag';
  nonMappedKeyToUpperCase?: boolean;
  os?: 'mac' | 'windows';
  size?: 'xsmall' | 'small';
};
export const KeyGroup = (props: Props) => {
  if (props.variant === 'tag') {
    return (
      <Text
        css={{
          display: 'flex',
          alignItems: 'center',
          background: theme.semantic.colour.surface.neutral.background2,
          borderRadius: theme.radii.xsmall,
          paddingBlock: theme.spacing.xsmall,
          paddingInline: theme.spacing.medium,
          gap: theme.spacing.small,
        }}
        size={props.size}
        weight="semibold"
      >
        {props.keys.map((key) => {
          return typeof key === 'string' ? (
            <span key={key}>
              {maybeMapCombinationKey({
                key,
                nonMappedKeyToUpperCase: props.nonMappedKeyToUpperCase,
                os: props.os,
              })}
            </span>
          ) : (
            key
          );
        })}
      </Text>
    );
  }

  return (
    <Text
      css={{
        color: theme.semantic.colour.text.textSecondary,
        display: 'flex',
        gap: theme.spacing.small,
      }}
      size={props.size}
      weight="regular"
    >
      {props.keys.map((key) => {
        return typeof key === 'string' ? (
          <span key={key}>
            {maybeMapCombinationKey({
              key,
              nonMappedKeyToUpperCase: props.nonMappedKeyToUpperCase,
              os: props.os,
            })}
          </span>
        ) : (
          key
        );
      })}
    </Text>
  );
};
